
"use client";

import React, { useEffect } from 'react';
import { signIn } from 'next-auth/react';

const LoginPage = () => {

  useEffect(() => {
    document.title = 'Sign in | Muster';
  }, []);

  return (
    <section className="login-container">
    <div className="container-fluid h-100">
        <div className="row h-100">
            <div className="col-12 col-md-6 text-center d-flex flex-column align-items-center justify-content-center position-relative">
              <div>
              {/* Decorative alt="" is intentional: the adjacent h1 conveys the Muster identity */}
              <img src="images/icons/muster-icon.png" alt="" width="200" height="200" className="mb-4" />
              <h1 className="fs-4 mb-5">Muster</h1>
                <button className="btn btn-primary w-100" onClick={() => {
                        signIn( 'azure-ad',
                        { callbackUrl: '/dashboard' },
                        { prompt: 'login' } )}}>
                    Sign in
                  </button>
              </div>
            <p className="position-absolute bottom-0 start-0 p-5 text-center text-md-start w-100">Muster 2026</p>
          </div>
          <div className="col-12 col-md-6 text-center bg-dark p-0 login-img d-none d-md-flex">

          </div>
      </div>
    </div>
  </section>
  )

};

export default LoginPage;